/* 邮件弹窗原生表单：一次用户操作只通知一次；不接管 Shopify/CAPTCHA 的请求。 */
(function () {
  'use strict';
  if (window.trlabEmailPopupForm) return;
  window.trlabEmailPopupForm = true;
  var forms = new WeakMap(), waiting = new Set();
  function stateFor(form) {
    var state = forms.get(form);
    if (!state) {
      // idle 可提交；pending 等待结果；retryable 超时/返回后等待用户主动重试。
      state = { status: 'idle', timer: null };
      forms.set(form, state);
    }
    return state;
  }
  function formFor(target) {
    return target && target.closest ? target.closest('form[data-email-popup-form]') : null;
  }
  function reset(form, state) {
    state.status = 'retryable';
    window.clearTimeout(state.timer);
    waiting.delete(form);
    form.removeAttribute('aria-busy');
    form.querySelectorAll('[type="submit"]').forEach(function (button) { button.removeAttribute('aria-disabled'); });
  }
  function onUserSubmit(event) {
    if (!event.isTrusted || event.defaultPrevented) return;
    var form = formFor(event.target);
    if (!form) return;
    if (event.type === 'click' && !event.target.closest('[type="submit"]')) return;
    if (event.type === 'keydown' && (event.key !== 'Enter' || event.isComposing ||
        !event.target.matches('input[type="email"]'))) return;
    var state = stateFor(form);
    if (state.status === 'pending' || event.repeat) { event.preventDefault(); return; }
    // 超时只开放按钮；必须有新的用户点击/回车，才能再次进入可提交状态。
    state.status = 'idle';
  }
  document.addEventListener('click', onUserSubmit, true);
  document.addEventListener('keydown', onUserSubmit, true);
  document.addEventListener('submit', function (event) {
    var form = formFor(event.target);
    if (!form || !form.checkValidity()) return;
    var state = stateFor(form);
    // 验证码续交属于当前提交，无论等待中还是已超时，都不另建一次尝试。
    // 不取消平台 submit：首次事件可能被平台拦截，续交才是完成原生请求。
    if (state.status !== 'idle') return;
    state.status = 'pending';
    waiting.add(form);
    form.setAttribute('aria-busy', 'true');
    form.querySelectorAll('[type="submit"]').forEach(function (button) { button.setAttribute('aria-disabled', 'true'); });
    // 网络无响应时恢复用户重试；超时本身不会新建意图，也不会重发请求或埋点。
    state.timer = window.setTimeout(function () { reset(form, state); }, 15000);
    var id = window.crypto && window.crypto.randomUUID ? window.crypto.randomUUID() :
      'submit_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2);
    form.dispatchEvent(new CustomEvent('email-popup:submit', { bubbles: true, detail: { submissionId: id } }));
  }, true);
  window.addEventListener('pageshow', function () {
    waiting.forEach(function (form) { reset(form, stateFor(form)); });
  });
  document.addEventListener('shopify:section:unload', function (event) {
    waiting.forEach(function (form) { if (event.target.contains(form)) reset(form, stateFor(form)); });
  });
})();
